<template>
  <div>
    <!--导航栏 start-->
    <van-nav-bar title="修改门店信息" left-text="返回" @click-left="onClickLeft" left-arrow fixed />
    <!--导航栏 end-->
    <!--内容部分 start-->
    <van-form ref="forms" style="margin-top: 1.2rem">
      <van-field
        v-model="store_name"
        label="门店名称"
        required
        name="门店名称"
        clearable
        placeholder="请输入门店名称"
        :rules="[{ required: true, message: '门店名称不能为空' }]"
      />
      <van-field
        v-model="store_contact"
        label="门店联系人"
        required
        name="门店联系人"
        clearable
        placeholder="请输入门店联系人"
        :rules="[{ required: true, message: '门店联系人不能为空' }]"
      />
      <van-field
        v-model="store_tel"
        label="门店手机号"
        required
        name="门店手机号"
        clearable
        placeholder="请输入门店手机号"
        :rules="[{ required: true, message: '门店手机号不能为空' }]"
      />
      <van-field v-model="store_info" label="门店信息" name="门店信息" clearable placeholder="请输入门店信息" />
      <van-field
        readonly
        clickable
        label="选择地址"
        :value="value"
        placeholder="请选择地址"
        @click="showPicker = true"
        required
        :rules="[{ required: true, message: '地址必须选择' }]"
      />
      <van-popup v-model="showPicker" round position="bottom">
        <van-picker show-toolbar :columns="area" @cancel="showPicker = false" @confirm="onConfirm" />
      </van-popup>
      <van-field
        readonly
        clickable
        label="店铺分类"
        :value="value2"
        placeholder="请店铺分类"
        @click="showPicker2 = true"
        required
        :rules="[{ required: true, message: '店铺分类必须选择' }]"
      />
      <van-popup v-model="showPicker2" round position="bottom">
        <van-picker
          show-toolbar
          :columns="type"
          @cancel="showPicker2 = false"
          @confirm="onConfirm2"
        />
      </van-popup>
      <van-field
        name="uploader"
        label="门店图片"
        required
        :rules="[{ required: true, message: '门店图片不能为空' }]"
      >
        <template #input>
          <van-uploader :after-read="afterRead" v-model="imageList" multiple :max-count="1" />
        </template>
      </van-field>
      <van-field
        name="uploader"
        label="轮播图"
        required
        :rules="[{ required: true, message: '轮播图不能为空' }]"
      >
        <template #input>
          <van-uploader :after-read="afterReads" v-model="imageLists" @delete="deletes" multiple />
        </template>
      </van-field>

      <van-field
        name="是否营业"
        label="是否营业"
        required
        :rules="[{ required: true, message: '是否营业必须选择' }]"
      >
        <template #input>
          <van-radio-group v-model="store_is_start" direction="horizontal">
            <van-radio :name="1">开业</van-radio>
            <van-radio :name="0">暂停营业</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        name="是否开通外卖"
        label="是否开通外卖"
        required
        :rules="[{ required: true, message: '是否开通外卖必须选择' }]"
      >
        <template #input>
          <van-radio-group v-model="is_delivery" direction="horizontal">
            <van-radio :name="1">是</van-radio>
            <van-radio :name="0">否</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        name="是否启用桌位"
        label="是否启用桌位"
        required
        :rules="[{ required: true, message: '是否启用桌位必须选择' }]"
      >
        <template #input>
          <van-radio-group v-model="is_seat" direction="horizontal">
            <van-radio :name="1">是</van-radio>
            <van-radio :name="0">否</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        name="是否先结账"
        label="是否先结账"
        required
        :rules="[{ required: true, message: '是否先结账必须选择' }]"
      >
        <template #input>
          <van-radio-group v-model="is_pre_pay" direction="horizontal">
            <van-radio :name="1">是</van-radio>
            <van-radio :name="0">否</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        v-model="print_num"
        label="打印小票数量"
        required
        name="打印小票数量"
        clearable
        placeholder="请输入打印小票数量"
        type="number"
        :rules="[{ required: true, message: '打印小票数量不能为空' }]"
      />
      <van-field
        v-if="is_delivery==1"
        v-model="delivery_money"
        label="配送费"
        required
        name="配送费"
        clearable
        placeholder="请输入配送费"
        :rules="[{ required: true, message: '配送费不能为空' }]"
      />
      <van-field
        name="店铺经营类型"
        label="店铺经营类型"
        required
        :rules="[{ required: true, message: '店铺经营类型必须选择' }]"
      >
        <template #input>
          <van-radio-group v-model="shop_type" direction="horizontal">
            <van-radio name="01">直营</van-radio>
            <van-radio name="02">加盟</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        readonly
        clickable
        label="餐饮类型"
        :value="value3"
        placeholder="选择餐饮类型"
        @click="showDinner_type = true"
      />
      <van-popup v-model="showDinner_type" round position="bottom">
        <van-picker
          show-toolbar
          :columns="dinner_typeList"
          @cancel="showDinner_type = false"
          @confirm="onConfirm3"
        />
      </van-popup>
      <van-field
        readonly
        clickable
        label="前台打印机"
        :value="default_printer"
        placeholder="选择前台打印机"
        @click="show_printer = true"
      />
      <van-popup v-model="show_printer" round position="bottom" closeable>
        <!-- <van-picker
          show-toolbar
          :columns="printer_list"
          @cancel="show_printer = false"
          @confirm="onConfirm4"
        />-->
        <div style="padding: 50px 0px;">
          <van-checkbox-group v-model="checkedValue" @change="changeCheckebox">
            <van-cell-group>
              <van-cell
                v-for="(item, index) in printer_list"
                clickable
                :key="index"
                :title="item.device_sn"
              >
                <template #right-icon>
                  <van-checkbox :name="item.device_sn" ref="checkboxes" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </div>
      </van-popup>
      <van-field
        readonly
        clickable
        label="后厨打印机"
        :value="chef_sn"
        placeholder="选择后厨打印机"
        @click="show_printer_chef = true"
      />
      <van-popup v-model="show_printer_chef" round position="bottom" closeable>
        <div style="padding: 50px 0px;">
          <van-checkbox-group v-model="checkedValueChef" @change="changeChef">
            <van-cell-group>
              <van-cell
                v-for="(item, index) in printer_list_chef"
                clickable
                :key="index"
                :title="item.device_sn"
              >
                <template #right-icon>
                  <van-checkbox :name="item.device_sn" ref="checkboxess" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </div>
      </van-popup>
    </van-form>
    <div style="margin: 16px;">
      <van-button @click="onSubmit" round block type="info" native-type="submit">确定</van-button>
    </div>

    <!--内容部分 end-->
  </div>
</template>

<script>
// import VueCookie from 'vue-cookies'
import { Notify, Toast } from "vant";
import Config from "../../../config";
import area from "@/utils/area.js";
import type from "@/utils/type.js";
export default {
  name: "StoresStoreInformationUpdate",
  data() {
    return {
      checkedValue: [],
      checkedValueChef: [],
      imageList: [{ url: "" }],
      imageLists: [],
      store_contact: "",
      store_img: "",
      order_group_images: [],
      store_is_start: "",
      is_delivery: 0,
      store_name: "",
      store_tel: "",
      store_info: "",
      value: "",
      value2: "",
      showPicker: false,
      showPicker2: false,
      area: [],
      type: [],
      alipay_city_code: "",
      alipay_district_code: "",
      alipay_province_code: "",
      alipay_shop_category: "",
      shop_type: "",
      delivery_money: "",
      showDinner_type: false,
      value3: "",
      dinner_type: "",
      default_printer: "",
      chef_sn: "",
      show_printer_chef: false,
      is_seat: 0,
      is_pre_pay: 0,
      print_num: 1,
      dinner_typeList: [
        {
          code: "A01",
          text: "正餐-本帮江浙菜",
        },
        {
          code: "A02",
          text: "正餐-日本菜",
        },
        {
          code: "A03",
          text: "正餐-西餐",
        },
        {
          code: "A04",
          text: "正餐-粤菜",
        },
        {
          code: "A05",
          text: "正餐-韩国料理",
        },
        {
          code: "A06",
          text: "正餐-川菜",
        },
        {
          code: "A07",
          text: "正餐-东南亚菜",
        },
        {
          code: "A08",
          text: "正餐-江河湖海鲜",
        },
        {
          code: "A09",
          text: "正餐-东北菜",
        },
        {
          code: "A10",
          text: "正餐-新疆菜",
        },
        {
          code: "A11",
          text: "正餐-素食",
        },
        {
          code: "A12",
          text: "正餐-湘菜",
        },
        {
          code: "A13",
          text: "正餐-早茶",
        },
        {
          code: "A14",
          text: "正餐-北京菜",
        },
        {
          code: "A15",
          text: "正餐-农家菜",
        },
        {
          code: "A16",
          text: "正餐-家常菜",
        },
        {
          code: "A17",
          text: "正餐-特色菜",
        },
        {
          code: "A18",
          text: "正餐-私房菜",
        },
        {
          code: "A19",
          text: "正餐-创意菜",
        },
        {
          code: "A20",
          text: "正餐-中东菜",
        },
        {
          code: "B01",
          text: "快餐-小吃快餐",
        },
        {
          code: "B02",
          text: "快餐-小龙虾",
        },
        {
          code: "B03",
          text: "快餐-烧烤烤串",
        },
        {
          code: "B04",
          text: "快餐-面馆",
        },
        {
          code: "B05",
          text: "快餐-烤肉",
        },
        {
          code: "C01",
          text: "火锅-火锅",
        },
        {
          code: "D01",
          text: "面包甜点-面包甜点",
        },
        {
          code: "E01",
          text: "茶饮咖啡-咖啡厅",
        },
        {
          code: "E02",
          text: "茶饮咖啡-饮品店",
        },
        {
          code: "F01",
          text: "零食卤味-水果生鲜",
        },
        {
          code: "F02",
          text: "零食卤味-食品保健",
        },
        {
          code: "F03",
          text: "零食卤味-卤味熟食",
        },
        {
          code: "F04",
          text: "零食卤味-零食干果",
        },
        {
          code: "G01",
          text: "酒餐-酒店自助餐",
        },
      ],
      show_printer: false,
      printer_list: [],
      printer_list_chef: [],
      activeIndexList: [],
      indexList: [],
      activeIndexListCode: [],
      activeIndexListCode1: [],
    };
  },
  // 组件内路由--进入组件时
  beforeRouteEnter(to, from, next) {
    window.document.body.style.backgroundColor = "#f5f5f5";
    next();
  },
  // 组件内路由--离开组件时
  beforeRouteLeave(to, from, next) {
    window.document.body.style.backgroundColor = "";
    next();
  },
  created() {
    this.id = this.$route.query.id;
    this.getStore();
    this.deviceList();
  },
  mounted() {
    this.area = area.area;
    this.type = type.type;
  },
  methods: {
    changeCheckebox(e) {
      this.default_printer = e.toString();
    },
    changeChef(e) {
      this.chef_sn = e.toString();
    },
    toggle(item, index) {
      console.log(item);
      this.$refs.checkboxes[index].toggle();
      this.activeIndexListCode.push(item.device_sn); // 选项code
      let arrCode = [];
      for (let i = 0; i < this.activeIndexListCode.length; i++) {
        if (arrCode.indexOf(this.activeIndexListCode[i]) == -1) {
          //选中的新数组里面没有相同的数据push到选中的新数组里面
          arrCode.push(this.activeIndexListCode[i]);
        } else if (arrCode.indexOf(this.activeIndexListCode[i]) > -1) {
          //选中的新数组里面有相同的数据，去掉选中的新数组里面的值,代表点击的行已被点击过，这次点击则删除选中数组里面的值
          let index = arrCode.indexOf(this.activeIndexListCode[i]);
          arrCode.splice(index, 1);
        }
      }

      this.activeIndexListCode = arrCode;
      this.default_printer = this.activeIndexListCode.toString();

      console.log(this.default_printer);
    },
    toggleChef(item, index) {
      console.log(item);
      this.$refs.checkboxess[index].toggle();
      this.activeIndexListCode1.push(item.device_sn); // 选项code
      let arrCode = [];
      for (let i = 0; i < this.activeIndexListCode1.length; i++) {
        if (arrCode.indexOf(this.activeIndexListCode1[i]) == -1) {
          //选中的新数组里面没有相同的数据push到选中的新数组里面
          arrCode.push(this.activeIndexListCode1[i]);
        } else if (arrCode.indexOf(this.activeIndexListCode1[i]) > -1) {
          //选中的新数组里面有相同的数据，去掉选中的新数组里面的值,代表点击的行已被点击过，这次点击则删除选中数组里面的值
          let index = arrCode.indexOf(this.activeIndexListCode1[i]);
          arrCode.splice(index, 1);
        }
      }

      this.activeIndexListCode1 = arrCode;
      this.chef_sn = this.activeIndexListCode1.toString();

      console.log(this.chef_sn);
    },
    deviceList() {
      this.$http.post("/wechat/api.store.index/deviceList").then((response) => {
        // response.data.data.forEach(element => {
        // console.log(element)
        // let obj = {
        // 	text:element.device_sn
        // }
        // this.printer_list.push(obj)
        // });
        this.printer_list = response.data.data;
        this.printer_list_chef = response.data.data;
        console.log("=======", this.printer_list);
      });
    },
    getSelectAlipayShopCategory(code, arr) {
      let index = 0;
      let p_index = 0;
      let text = "";
      let p_text = "";
      for (let i = 0; i < arr.length; i++) {
        let children = arr[i].children;
        for (let j = 0; j < children.length; j++) {
          if (children[j].code == code) {
            p_index = i;
            index = j;
            p_text = arr[i].text;
            text = children[j].text;
          }
        }
      }
      return { p_index, index, p_text, text };
    },
    onConfirm(value, index) {
      this.value = value;
      this.alipay_province_code = this.area[index[0]].code;
      this.alipay_city_code = this.area[index[0]].children[index[1]].code;
      this.alipay_district_code =
        this.area[index[0]].children[index[1]].children[index[2]].code;
      this.showPicker = false;
    },
    onConfirm2(value, index) {
      this.value2 = value;
      this.alipay_shop_category = this.type[index[0]].children[index[1]].code;
      this.showPicker2 = false;
    },
    onConfirm3(value, index) {
      this.value3 = value.text;
      this.dinner_type = value.code;
      this.showDinner_type = false;
    },
    onConfirm4(value) {
      console.log(value);
      this.default_printer = value.text;
      this.show_printer = false;
    },
    getStore(res) {
      this.$http
        .get("/wechat/api.merchant_info/get_store_info", {
          params: {
            merchant_id: window.sessionStorage.getItem("commercialId"),
            store_id: window.sessionStorage.getItem("store_id"),
          },
        })
        .then((response) => {
          if (response && response.body.code == 200) {
            this.store_contact = response.body.data.store_contact;
            this.store_is_start = response.body.data.store_is_start;
            this.is_delivery = response.body.data.is_delivery;
            this.store_name = response.body.data.store_name;
            this.store_tel = response.body.data.store_tel;
            this.store_info = response.body.data.store_info;
            this.shop_type = response.body.data.shop_type;
            this.alipay_city_code = response.body.data.alipay_city_code;
            this.alipay_district_code = response.body.data.alipay_district_code;
            this.alipay_province_code = response.body.data.alipay_province_code;
            this.alipay_shop_category = response.body.data.alipay_shop_category;
            this.delivery_money = response.body.data.delivery_money;
            this.dinner_type = response.body.data.dinner_type;
            this.is_seat = response.body.data.is_seat;
            this.is_pre_pay = response.body.data.is_pre_pay;
            this.print_num = response.body.data.print_num;
            this.default_printer = response.body.data.default_printer;
            if (response.body.data.default_printer) {
              this.checkedValue = response.body.data.default_printer.split(",");
            }
            this.chef_sn = response.body.data.chef_sn;
            if (response.body.data.chef_sn) {
              this.checkedValueChef = response.body.data.chef_sn.split(",");
            }
            this.dinner_typeList.map((i) => {
              if (this.dinner_type == i.code) {
                this.value3 = i.text;
              }
            });

            let index_arr = [];
            let text_arr = [];
            let sheng_code = this.alipay_province_code;
            let shi_code = this.alipay_city_code;
            let qu_code = this.alipay_district_code;
            for (let i0 = 0; i0 < this.area.length; i0++) {
              if (this.area[i0].code == sheng_code) {
                index_arr[0] = i0;
                text_arr[0] = this.area[i0].text;
                let shi_arr = this.area[i0].children;
                for (let i1 = 0; i1 < shi_arr.length; i1++) {
                  if (shi_arr[i1].code == shi_code) {
                    index_arr[1] = i1;
                    text_arr[1] = shi_arr[i1].text;
                    let qu_arr = shi_arr[i1].children;
                    for (let i2 = 0; i2 < qu_arr.length; i2++) {
                      if (qu_arr[i2].code == qu_code) {
                        index_arr[2] = i2;
                        text_arr[2] = qu_arr[i2].text;
                      }
                    }
                  }
                }
              }
            }
            this.value = text_arr;
            let select = this.getSelectAlipayShopCategory(
              this.alipay_shop_category,
              this.type
            );
            console.log("ddddddddddd", select);
            if (select.p_text != "") {
              this.value2 = select.p_text + "," + select.text;
            }
            if (response.body.data.store_img) {
              this.imageList[0].url =
                Config.baseURL + response.body.data.store_img;
              this.store_img = response.body.data.store_img;
            } else {
              this.imageList = [];
              this.store_img = null;
            }
            if (response.body.data.order_group_images) {
              this.imageLists = [];
              response.body.data.order_group_images.map((item) => {
                let obj = { url: Config.baseURL + item };
                this.imageLists.push(obj);
              });

              this.order_group_images = response.body.data.order_group_images;
            } else {
              this.imageLists = [];
              this.order_group_images = null;
            }
          }
        });
    },
    afterRead(file) {
      this.$http
        .post("/wechat/api.merchant/wechatUploadMerchantImg", {
          localData: file.content,
          openid: window.localStorage.getItem("openid"),
        })
        .then((response) => {
          if (response && response.data.code == 200) {
            this.store_img = response.data.local_img;
          }
        });
    },
    afterReads(file) {
      this.$http
        .post("/wechat/api.merchant/wechatUploadMerchantImg", {
          localData: file.content,
          openid: window.localStorage.getItem("openid"),
        })
        .then((response) => {
          if (response && response.data.code == 200) {
            this.order_group_images.push(response.data.local_img);
          }
        });
    },
    deletes(file, detail) {
      this.order_group_images.splice(detail.index, 1);
    },

    // 左侧返回
    onClickLeft() {
      this.$router.push("/StoresStoreInformation");
      // window.history.go(-1)
    },
    // 提交
    onSubmit() {
      // if(this.coupon_divide==''&&this.coupon_divide==null){
      //   this.coupon_divide=0;
      // }
      this.$refs.forms
        .validate()
        .then(() => {
          var toast = Toast.loading({
            duration: 0,
            message: "添加中",
            forbidClick: true,
            loadingType: "spinner",
          });
          this.$http
            .post("/wechat/api.store.index/updateStore", {
              store_contact: this.store_contact,
              store_is_start: this.store_is_start,
              is_delivery: this.is_delivery,
              store_name: this.store_name,
              store_tel: this.store_tel,
              store_info: this.store_info,
              store_img: this.store_img,
              order_group_images: this.order_group_images,
              alipay_city_code: this.alipay_city_code,
              alipay_district_code: this.alipay_district_code,
              alipay_province_code: this.alipay_province_code,
              alipay_shop_category: this.alipay_shop_category,
              shop_type: this.shop_type,
              delivery_money: this.delivery_money,
              dinner_type: this.dinner_type,
              is_seat: this.is_seat,
              is_pre_pay: this.is_pre_pay,
              print_num: this.print_num,
              default_printer: this.default_printer,
              chef_sn: this.chef_sn,
              // openid: window.localStorage.getItem("openid")
            })
            .then((response) => {
              toast.clear();
              if (response && response.data.code == 200) {
                this.$router.push("/StoresStoreInformation");

                // VueCookie.set('salesmanInfo', response.data.data, 360000);
                // window.location.href = that.redirect;
              } else {
                Notify({ type: "danger", message: response.data.msg });
              }
            });
        })
        .catch(() => {
          this.$toast.fail("必填项未填写");
        });
      // window.sessionStorage.setItem("tag",this.ta)
      //  var that = this;
    },
  },
};
</script>

<style >
.van-icon-goods-collect-o::before {
  position: relative;
  top: 0.1rem;
}
.van-icon-contact::before {
  position: relative;
  top: 0.1rem;
}

.van-field >>> .van-field__label {
  width: 30px;
}
</style>
